var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "DownloadApp white--bg pa-6"
  }, [_c('div', {
    staticClass: "logo mb-10"
  }, [_c('div', {
    staticClass: "top-left-logo"
  }, [_vm.theme.topLeftLogo ? _c('img', {
    attrs: {
      "src": _vm.theme.topLeftLogo
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "top-right-logo ml-auto"
  }, [_vm.theme.topRightLogo ? _c('img', {
    attrs: {
      "src": _vm.theme.topRightLogo
    }
  }) : _vm._e()])]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ricotta titanic--text mb-4"
  }, [_vm._v(" Добро пожаловать ")]), _c('div', {
    staticClass: "parmigiano titanic--text mb-8"
  }, [_vm._v(" Наше приложение делает работу сотрудников комфортнее и проще, а руководителям позволяет эффективнее выстравивать и контролировать бизнес-процессы ")]), _c('r-button', {
    staticClass: "mb-6",
    attrs: {
      "title": "Скачать мобильное приложение",
      "icon": "load",
      "size": "helike",
      "width": "wide",
      "type": "primary",
      "color": "rocky"
    },
    on: {
      "click": _vm.toDownloadLink
    }
  }), _c('r-button', {
    attrs: {
      "title": "Быстрая настройка сервера",
      "icon": "button",
      "size": "helike",
      "width": "wide",
      "type": "secondary",
      "color": "rocky"
    },
    on: {
      "click": _vm.toSettings
    }
  })], 1), _c('div', {
    staticClass: "copyrights mt-10"
  }, [_c('img', {
    staticClass: "mb-4",
    attrs: {
      "src": "/themes/consumption/login-page-top-logo.svg"
    }
  }), _c('div', {
    staticClass: "mozzarella metropolis--text ekas",
    domProps: {
      "innerHTML": _vm._s(_vm.getCopyrightText())
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }